export const canvasToBlobPromise = (canvas: HTMLCanvasElement): Promise<Blob> =>
  new Promise((resolve) => {
    canvas.toBlob((blob) => {
      resolve(blob);
    });
  });
